import { render, staticRenderFns } from "./SearchProgressBar.vue?vue&type=template&id=20545fd0&scoped=true"
import script from "./SearchProgressBar.vue?vue&type=script&lang=js"
export * from "./SearchProgressBar.vue?vue&type=script&lang=js"
import style0 from "./SearchProgressBar.vue?vue&type=style&index=0&id=20545fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20545fd0",
  null
  
)

export default component.exports